import React from 'react'
import { Link } from 'react-router-dom'

const GoodAction = ({ good, decrease, increase }: any) => {
  return (
    <div className="good-action">
      {good.is_rest ? (
        <div className="sold-out">休息中</div>
      ) : parseInt(good.buy_count) ? (
        <div className="good-number">
          <img
            className="decrease"
            src="/public/assets/img/good-decrease.png"
            onClick={(e) => {e.preventDefault();decrease(good.goods_id)}}
            alt=""
          />

          <span className="amount">{good.buy_count}</span>

          <img
            src="/public/assets/img/good-increase.png"
            className="increase"
            onClick={e => {e.preventDefault();increase(e, good.goods_id)}}
            alt=""
          />
        </div>
      ) : parseInt(good.stock) ? (
        <div onClick={e => {e.preventDefault();increase(e, good.goods_id)}} className="good-cart">
          <img src="/public/assets/img/add_shopping_cart.png" alt="" />
        </div>
      ) : (
        <div className="sold-out">已抢光</div>
      )}
    </div>
  )
}

export default (props: any) => {
  const { good } = props
  return (
    <Link to={`/goods-detail/${good.goods_id}`}>
      <div className="good">
        <div className="good-cover">
          <img src={good.cover} alt="" />
        </div>
        <div className="good-info">
          <div className="good-title text-ell">{good.title}</div>
          <div className="good-subtitle">{good.brief}</div>
          <div className="good-prices">
            <span className="c-price">
              {/* <span className="rmb font-9">&yen;</span> */}
              会员价：{good.current_price}元
            </span>
            <span className="o-price font-9">
              {/* <span className="rmb font-9">&yen;</span> */}
              零售价：{good.original_price}元
            </span>
          </div>
          <GoodAction {...props} />
        </div>
      </div>
    </Link>
  )
}
